import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=a7d93dd8&scoped=true&"
import script from "./ArticleAdd.vue?vue&type=script&lang=js&"
export * from "./ArticleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d93dd8",
  null
  
)

export default component.exports